import SpecialText from "./SpecialText";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { CGI_GRADIENT_B_45DEG } from "../helpers/enums";

export default function AboutCGI() {
  const { t } = useTranslation();

  const cgiTextSx = {
    fontSize: { xs: 12, md: 13 },
    fontFamily: "Inter",
    mb: 3,
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: { xs: 0.9, md: 1 / 2 },
        mr: 12,
      }}
    >
      <Typography
        align="left"
        sx={{
          fontSize: { xs: 30, md: 55 },
          lineHeight: 1,
          py: 1,
          whiteSpace: "pre-wrap",
          mb: { xs: 2.5, md: 7 },
          fontWeight: 500,
        }}
      >
        <SpecialText
          style={{
            background: CGI_GRADIENT_B_45DEG,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {t("insights")}
        </SpecialText>
        {`\n${t("aboutCGI")}`}
      </Typography>
      <Typography sx={cgiTextSx}>{t("founded")}</Typography>
      <Typography sx={cgiTextSx}>{t("weKnow")}</Typography>
      <Typography sx={cgiTextSx}>{t("across")}</Typography>
    </Box>
  );
}
